module.exports = __webpack_public_path__ + "img/sol_cap5.88aff9cf.png";